import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

interface Phase2NoticeModalProps {
  show: boolean
  onClose: () => void
}

export const Phase2NoticeModal: React.FC<Phase2NoticeModalProps> = ({ show, onClose }) => {
  const { t } = useTranslation()

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{t('phase2_title')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex gap-3 align-items-start">
          <i className="bi bi-info-circle-fill text-primary fs-3" aria-hidden="true"></i>
          <div>
            <p className="mb-2">{t('phase2_notice_line1')}</p>
            <p className="mb-0">{t('phase2_notice_line2')}</p>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onClose}>
          {t('understood')}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default Phase2NoticeModal
